export declare class Environment {
    constructor();
    setup(): Promise<void>;
}
